// extracted by mini-css-extract-plugin
export default {"floatingButton":"NewPost_floatingButton__Cmr-x"};